import { ServiceConfig } from "../typing";


export const validateGraphQLServer = (server?: ServiceConfig) => {
    if (!server || !server.urlOrigin) throw new Error('No graphQL service config available')
    return;
}